<template>
  <div>
    <HierarchicalDataSource
      ref="remoteDatasource"
      :type="'jsonp'"
      :transport-read-url="'http://localhost:8088/getVendor'"
      :schema-model="dsModel"
    >
    </HierarchicalDataSource>
    <TreeView
      :data-text-field="'name'"
      :data-source-ref="'remoteDatasource'"
      :template="template"
    >
    </TreeView>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import '@progress/kendo-ui/js/kendo.data'
import '@progress/kendo-ui/js/kendo.treeview'
import { TreeView } from '@progress/kendo-treeview-vue-wrapper'
import { HierarchicalDataSource } from '@progress/kendo-datasource-vue-wrapper'

export default defineComponent({
  components: {
    TreeView,
    HierarchicalDataSource
  },
  data: function() {
    return {
      template:
        '# if (item.isParent) { #' +
        `<span class='k-icon k-i-link-horizontal'></span>
          <span class='k-icon k-i-cloud'></span>` +
        '# } #' +
        '# if (!item.isParent) { #' +
        "<span class='k-icon k-i-user'></span>" +
        '# } #' +
        '#: item.name #',
      dsModel: {
        id: 'id',
        hasChildren: 'isParent',
        children: {
          type: 'jsonp',
          transport: {
            read: {
              url: 'http://localhost:8088/getSwitchByVendor'
            }
          },
          schema: {
            model: {
              id: 'id',
              hasChildren: 'isParent',
              children: {
                type: 'jsonp',
                transport: {
                  read: {
                    url: 'http://localhost:8088/getPorts'
                  }
                },
                schema: {
                  model: {
                    id: 'id',
                    hasChildren: false
                  }
                }
              }
            }
          }
        }
      }
    }
  }
})
</script>

<style scoped>
#treeview :deep(.k-sprite) {
  background-image: url('https://demos.telerik.com/kendo-ui/content/web/treeview/coloricons-sprite.png');
}

:deep(.rootfolder) {
  background-position: 0 0;
}
:deep(.folder) {
  background-position: 0 -16px;
}
:deep(.pdf) {
  background-position: 0 -32px;
}
:deep(.html) {
  background-position: 0 -48px;
}
:deep(.image) {
  background-position: 0 -64px;
}
</style>
